<template>
    <div class="card-205 col-12 border">
        <div class="card-205-image-container">
            <img class="col-12 card-205-image" :src="image" :alt="alt"/>
        </div>
        <div class="card-205-content row p-4">
            <div class="col-10 card-205-content-wrapper">
                <div class="col-12 card-205-content-title text-right p-4">
                    <slot name="p-1" >
                        مشاوره رایگان
                    </slot>
                </div>
                <div class="col-12 card-205-content-description text-right px-4">

                        <slot name="p-2">
                            <p>
                            با مشاورین ایران کانادا تماس بگیرید و پاسخ سوالات خود را دریافت کنید
                            </p>
                        </slot>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
import mImg from "../Tags/Img";
import {CardProps} from "../Cards/CardProps";
import mA from "../Tags/A";

export default {
    name: "Card205",
    components: {
        mA,
        mImg,
    },
    props: {
        ...CardProps,
    },
}
</script>

<style scoped>
.card-205 {
    border-radius: 12px;
    position: relative;
}

.card-205-image-container {
    width: 140px;
}

.card-205-image {
    object-fit: cover;
    border-radius: 20%;
    top: 35%;
    right: -70px;
    position: absolute;
    width: 130px;
    height: 70px;
}
</style>